import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { FinanceGetDimensionValuesDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

import EditDimensionValueSidepanel from 'modules/finance/components/Dimensions/EditDimensionValueSidepanel'

const EditValue = () => {
  const { id, value_id } = useParams()
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const [fetch] = useLazyQuery(FinanceGetDimensionValuesDocument, {
    variables: {
      dimensionId: Number(id),
      tenant: { companyId: company.id },
    },
  })

  const onEdit = () => {
    fetch()

    navigate(
      navigation.settings.finance.dimensions.dimension.values.fullPath({
        id: Number(id),
        value_id: Number(value_id),
      })
    )
  }

  return (
    <>
      {id && value_id && (
        <EditDimensionValueSidepanel value_id={Number(value_id)} onClose={onEdit} />
      )}
    </>
  )
}

export default observer(EditValue)
